<template>
  <div class="trend-view-root">
    <div class="wrapper">
      <div>
        <el-date-picker
          :autofocus="false"
          v-model="date"
          type="daterange"
          align="right"
          unlink-panels
          @change="handleTimeChange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :shortcuts="shortcuts"
        >
        </el-date-picker>
      </div>

      <el-row :gutter="10" style="margin-top: 20px">
        <el-col :span="12"
          ><div
            v-loading="chartList[0].loading"
            id="boundlenum"
            style="height: 210px"
          ></div
        ></el-col>
        <el-col :span="12"
          ><div
            v-loading="chartList[1].loading"
            id="boundletypesnum"
            style="height: 210px"
          ></div
        ></el-col>
      </el-row>
      <el-row :gutter="10" style="margin-top: 10px">
        <el-col :span="12"
          ><div
            v-loading="chartList[2].loading"
            id="assetsnum"
            style="height: 210px"
          ></div
        ></el-col>
        <el-col :span="12"
          ><div
            v-loading="chartList[3].loading"
            id="assetdepsnum"
            style="height: 210px"
          ></div
        ></el-col>
      </el-row>
      <el-row :gutter="10" style="margin-top: 10px">
        <el-col :span="12"
          ><div
            v-loading="chartList[4].loading"
            id="assetsTypenum"
            style="height: 210px"
          ></div
        ></el-col>
        <el-col :span="12"
          ><div
            v-loading="chartList[5].loading"
            id="assetsTypesize"
            style="height: 210px"
          ></div
        ></el-col>
      </el-row>
      <el-row :gutter="10" style="margin-top: 10px">
        <el-col :span="12"
          ><div
            v-loading="chartList[6].loading"
            id="packageSize"
            style="height: 210px"
          ></div
        ></el-col>
        <el-col :span="12"
          ><div
            v-loading="chartList[7].loading"
            id="sceneNum"
            style="height: 210px"
          ></div
        ></el-col>
      </el-row>
      <el-row :gutter="10" style="margin-top: 10px">
        <el-col :span="12"
          ><div
            v-loading="chartList[8].loading"
            id="avgAssets"
            style="height: 210px"
          ></div
        ></el-col>
        <el-col :span="12"
          ><div
            v-loading="chartList[9].loading"
            id="avgBoundleSize"
            style="height: 210px"
          ></div
        ></el-col>
      </el-row>
    </div>
    <div class="nochooseappcss" v-if="nochooseapp">
      <span>请选择要查看趋势的应用</span>
    </div>
  </div>
</template>

<script setup>
import {
  ref,
  getCurrentInstance,
  defineExpose,
  defineProps,
  onMounted,
  onBeforeUnmount,
} from "vue";
import * as echarts from "echarts";
import {
  apiPackageParseDiagram,
  apiPackageParseDiagramSuffix,
} from "@/Api/AppApi";
import { humanSize } from "@/Utils/UtilTools";

const props = defineProps(["appid"]);
defineExpose({ loadChartData });

const { appContext } = getCurrentInstance();
const $moment = appContext.config.globalProperties.$moment;

const nochooseapp = ref(false);

const shortcuts = [
  {
    text: "最近一周",
    value: () => {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
      return [start, end];
    },
  },
  {
    text: "最近一个月",
    value: () => {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      return [start, end];
    },
  },
  {
    text: "最近三个月",
    value: () => {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
      return [start, end];
    },
  },
];

const chartList = [
  { id: "boundlenum", types: ["bundle_number"], loading: false },
  {
    id: "boundletypesnum",
    types: ["bundle_dep_bundle", "circle_number", "asset_too_little"],
    loading: false,
  },
  { id: "assetsnum", types: ["asset_number"], loading: false },
  { id: "assetdepsnum", types: ["asset_dep_bundle"], loading: false },
  { id: "assetsTypenum", types: ["suffix_file_sum"], loading: false },
  { id: "assetsTypesize", types: ["suffix_file_size"], loading: false },
  { id: "packageSize", types: ["package_size"], loading: false },
  { id: "sceneNum", types: ["scene_number"], loading: false },
  { id: "avgAssets", types: ["average_assets"], loading: false },
  { id: "avgBoundleSize", types: ["average_bundle_size"], loading: false },
];

const date = ref(null);
onMounted(() => {
  date.value = [$moment().subtract(2, "month"), $moment()];
});

onBeforeUnmount(() => {
  for (const key in chartMap) {
    if (chartMap[key]) {
      chartMap[key].dispose();
      delete chartMap[key];
    }
  }
});

function handleTimeChange() {
  loadChartData();
}

async function loadChartData() {
  if (props.appid.length === 0) {
    nochooseapp.value = true;
  } else {
    nochooseapp.value = false;
    echarts.connect("group1");
    for (const chart of chartList) {
      const data = {
        st: date.value[0],
        et: date.value[1],
        appid: props.appid,
        type: chart.types,
      };
      chart.loading = true;
      if (chart.id === "assetsTypenum" || chart.id === "assetsTypesize") {
        apiPackageParseDiagramSuffix(data).then((res) => {
          chart.loading = false;
          if (res.code === 0) {
            for (const chartData of res.data) {
              drawTypeChartData(chartData, chart.id);
            }
          }
        });
      } else {
        apiPackageParseDiagram(data).then((res) => {
          chart.loading = false;
          if (res.code === 0) {
            const chartData = res.data;
            drawChartData(chartData, chart.id);
          }
        });
      }
    }
  }
}

const chartMap = {};
const chartOption = {
  xAxis: {
    type: "category",
    data: [],
  },
  grid: {
    top: 10,
  },
  legend: {
    left: "center",
    top: 170,
    data: [],
  },
  tooltip: {
    trigger: "axis",
  },
  yAxis: {
    type: "value",
    min: showYmin,
  },
  series: [],
};
function showYmin(v) {
  const d = Math.round(v.min - (v.max - v.min) / 6);
  return d < 0 ? 0 : d;
}
function yAxisFormatter(value) {
  return humanSize(value, 2);
}
function tooltipformater(params) {
  let res = "";
  for (let i = 0; i < params.length; i++) {
    const param = params[i];
    if (i === 0) {
      res += param.name + "<br/>";
    }
    res +=
      param.marker +
      param.seriesName +
      " : " +
      humanSize(param.value, 2) +
      "<br/>";
  }
  return res;
}

function drawTypeChartData({ data }, id) {
  if (chartMap[id] == undefined || chartMap[id] == null) {
    chartMap[id] = echarts.init(document.getElementById(id));
    chartMap[id].group = "group1";
  } else {
    chartMap[id].clear();
  }

  let xAxisData = [];
  const series = [];
  const legendData = [];
  const selected = {};
  if (data != null) {
    for (let j = 0; j < data.length; j++) {
      const dataItem = data[j];
      const suffix = dataItem.suffix;
      legendData.push(suffix);
      const serieItem = {
        name: suffix,
        type: "line",
        smooth: true,
        data: [],
      };
      selected[suffix] = j < 5;
      xAxisData = []; // TODO 为何清空
      for (const item of dataItem.data) {
        xAxisData.push($moment(item.Times).format("YYYY-MM-DD hh:mm:ss"));
        serieItem.data.push(item.Value);
      }
      series.push(serieItem);
    }
  }

  const option = JSON.parse(JSON.stringify(chartOption));
  option.xAxis.data = xAxisData;
  option.yAxis.min = showYmin;
  option.legend.data = legendData;
  option.legend.selected = selected;
  option.legend.type = "scroll";
  option.series = series;
  if (id === "assetsTypesize") {
    option.yAxis.axisLabel = { formatter: yAxisFormatter };
    option.tooltip.formatter = tooltipformater;
  }
  chartMap[id].setOption(option);
}

const lineName = {
  bundle_number: "AB数量",
  bundle_dep_bundle: "总依赖AB大于 50个以上的AB总数",
  circle_number: "循环依赖",
  asset_too_little: "只含有2个及以下资源的AB数量 ",
  asset_number: "资源数量",
  asset_dep_bundle: "单个资源 依赖AB数量大于20个以上的资源总数",
  suffix_file_sum: "每种后缀分类资源数量",
  suffix_file_size: "每种后缀分类资源大小",
  package_size: "包体大小",
  scene_number: "场景数量",
  average_assets: "每个AB中的文件数量平均",
  average_bundle_size: "每个AB的平均大小",
};
function drawChartData(data, id) {
  if (chartMap[id] == undefined || chartMap[id] == null) {
    chartMap[id] = echarts.init(document.getElementById(id));
    chartMap[id].group = "group1";
  } else {
    chartMap[id].clear();
  }
  let xAxisData = [];
  const series = [];
  const legendData = [];
  for (const dataItem of data) {
    legendData.push(lineName[dataItem.name]);
    const serieItem = {
      name: lineName[dataItem.name],
      type: "line",
      smooth: true,
      data: [],
    };
    xAxisData = []; // TODO 为何清空
    for (const item of dataItem.data) {
      xAxisData.push($moment(item.Times).format("YYYY-MM-DD hh:mm:ss"));
      serieItem.data.push(item.Value);
    }
    series.push(serieItem);
  }

  const option = JSON.parse(JSON.stringify(chartOption));
  option.xAxis.data = xAxisData;
  option.yAxis.min = showYmin;
  option.legend.data = legendData;
  option.series = series;
  if (id === "packageSize" || id === "avgBoundleSize") {
    option.yAxis.axisLabel = { formatter: yAxisFormatter };
    option.tooltip.formatter = tooltipformater;
  }
  chartMap[id].setOption(option);
}
</script>

<style lang="scss" scoped>
.trend-view-root {
  overflow: hidden;
  width: 100%;
  height: 100%;
  position: relative;
}

.wrapper {
  padding: 0 20px 20px 20px;
  overflow-y: auto;
  overflow-x: hidden;
  width: 100%;
  height: 100%;
}

.nochooseappcss {
  position: absolute;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  top: 0;
  color: #898989;
  background-color: #fff;
}

.el-col > div {
  border: 1px solid #e0e0e0;
}
</style>
